<template>
  <div v-show="isLoaded" class="mRitualRed-container" v-observe-visibility="startAnimate">
    <div class="mRitualRed-title">
      <h2 class="title" :class="{animate: animate}">Ritual del Servido</h2>
    </div>
    <img class="mRitualRed-fresas" v-observe-visibility="startAnimate" :src="fresa" :class="{animate: animate}" alt="Fresas">
    <swiper ref="mySwiper" class="swiper" :options="swiperOption">
      <swiper-slide>
        <div class="slide-container">
          <img class="mRitualRed" :src="paso1" alt="Paso 1">
          <p class="step step-1" :class="{onlySafari: isSafari}">Sirve tu vaso con <br>hielo a una altura<br> de 1/3 del vaso.</p>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="slide-container">
          <img class="mRitualRed" :src="paso2" alt="Paso 2">
          <p class="step step-2" :class="{onlySafari: isSafari}">Agrega Strongbow <br>preferida</p>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="slide-container">
          <img class="mRitualRed three" :src="paso3" alt="Paso 3">
          <p class="step step-3" :class="{onlySafari: isSafari}">Agrega una banderilla<br> de frutas para un toque <br>más fresco y elegante.</p>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import fresa from '@/assets/red-berries/fresas.png';
import paso1 from '@/assets/red-berries/1.png';
import paso2 from '@/assets/red-berries/2.png';
import paso3 from '@/assets/red-berries/3.png';
import { mapGetters } from "vuex";
import Bowser from "bowser";
import { Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: "RitualRed",
  data() {
    return {
      fresa,
      paso1,
      paso2,
      paso3,
      animate: false,
      isSafari: false,
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 30,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    };
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible) {
      if(isVisible) {
        this.animate=true
      }
    }
  },
  components: {
    Swiper, SwiperSlide  
  },
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/RedBerries/RitualRed.scss";
</style>

<style lang="scss">
.mRitualRed-container {
  .swiper-container {
    width: 100%;
    height: 100%;
    margin-top: -8vw;
  }
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    //background: #e9d166;
    width: 83%;
    /* Center slide text vertically */
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>